export default __webpack_public_path__ + "static/media/image-upload-text.f8d0c889.svg";